import { OrderedSet } from 'immutable'
import { RxCustomerAPI } from '@driftt/dapper'
import { Event, Property } from './models'

export const api = {
  fetch(orgId) {
    return RxCustomerAPI
      .get(`/organizations/${orgId}/end_users/attributes2`)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(({ events, properties }) => ({
        events: OrderedSet(events).map(Event),
        properties: OrderedSet(properties).map(Property),
      }))
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/attribute/api.js